import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { Button, Glyphicon } from 'react-bootstrap'
import { getSubModalStyles } from '../../../common/utils'

type Props = {
  isModalOpen: Boolean,
  closeModal: Function,
  submitVendor: Function,
  removeVendor: Function,
  vendor: {
    _id: String,
    email: String,
    name: String,
    tags: [String],
  },
}

const HandleVendorModal = ({ isModalOpen, closeModal, vendor, submitVendor, removeVendor }: Props) => {
  const [email, setEmail] = useState()
  const [name, setName] = useState()
  const [tags, setTags] = useState()
  const [password, setPassword] = useState()

  useEffect(() => {
    if (vendor) {
      setEmail(vendor.email)
      setName(vendor.name)
      setTags((vendor.tags || []).join('; '))
    } else {
      setEmail('')
      setName('')
      setTags('')
    }
  }, [vendor])

  return (
    <Modal isOpen={isModalOpen} onRequestClose={closeModal} style={getSubModalStyles()}>
      {vendor && (
        <div>
          <button onClick={closeModal}>Stäng</button>
          <hr />
          <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
            <label style={{ paddingRight: 21 }}>Email:</label>
            <input defaultValue={vendor.email} onChange={(e) => setEmail(e.target.value.trim())} className="change-input form-control" type="email" />
          </div>
          <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
            <label style={{ paddingRight: 21 }}>Namn:</label>
            <input defaultValue={vendor.name} onChange={(e) => setName(e.target.value)} className="change-input form-control" type="text" />
          </div>
          <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
            <label style={{ paddingRight: 21 }}>Taggar:</label>
            <input defaultValue={vendor.tags ? vendor.tags.join(';') : []} onChange={(e) => setTags(e.target.value)} className="change-input form-control" type="text" />
          </div>
          <div className="flex" style={{ justifyContent: 'flex-start', padding: 7 }}>
            <label style={{ paddingRight: 21 }}>Lösenord:</label>
            <input defaultValue="" onChange={(e) => setPassword(e.target.value)} className="change-input form-control" type="text" />
          </div>

          <br />

          <Button
            className="save-settings-btn"
            style={{ width: '50%', marginLeft: '25%', borderRadius: 25 }}
            type="submit"
            onClick={() =>
              submitVendor({
                _id: vendor._id,
                email,
                name,
                tags: tags.split(';').reduce((acc, t) => {
                  const trimmed = t.trim()

                  return trimmed ? acc.concat(trimmed) : acc
                }, []),
                password,
              })
            }
          >
            <Glyphicon glyph="glyphicon glyphicon-pencil" /> &nbsp; Spara
          </Button>

          <br />
          <br />

          <Button className="smallQbuttonWarning" style={{ width: '50%', marginLeft: '25%' }} type="submit" onClick={removeVendor}>
            <Glyphicon glyph="glyphicon glyphicon-remove" /> &nbsp; Ta bort leverantör
          </Button>
        </div>
      )}
    </Modal>
  )
}

export default HandleVendorModal
